import { Component, Input } from '@angular/core'
import { dateRoundOff, fullDayWithTime } from 'utils'
import { Customer } from '../../src/pages/dashboard-page/dashboard.queries'
import pluralize from 'pluralize'

@Component({
  selector: 'customer-credits',
  template: `
    <div class="text-center small-bottom-buffer mt-2 smallish">
      <div
        [tooltip]="creditsTooltip"
        placement="bottom"
        containerClass="white-tooltip">
        <span class="chip mr-1 text-center">
          {{customer.multipass ? customer.balance : customer.postCreditsCount}}
        </span>
        {{ 'credit' | pluralize:customer.multipass ? customer.balance : customer.postCreditsCount }} available
      </div>
      <div *ngIf="pastDue" class="my-4 text-center">
        <span class="alert alert-error">{{ pastDueMessage }}</span>
      </div>
    </div>
  `
})
export class CustomerCredits {
  @Input() customer: Customer

  get creditsTooltip(): string {
    if (this.customer.subscription?.scheduledToCancelAt) {
      return `This subscription is scheduled to cancel at ${fullDayWithTime(this.customer.subscription.scheduledToCancelAt, true)}`
    } else if (this.customer.subscription?.scheduledToPauseAt) {
      return `This subscription is scheduled to pause at ${fullDayWithTime(this.customer.subscription.scheduledToPauseAt, true)}`
    } else if (['active', 'paused'].includes(this.customer?.subscription?.state)) {
      const creditInfo = this.nextCreditsInfo
      // const nextCredits = this.customer.scheduledSubscription ? this.customer.scheduledSubscription.quantity : this.customer.subscription.quantity
      const creditsMonthly = pluralize(`${creditInfo.quantity} credit`, creditInfo.quantity)
      let renewalDay = dateRoundOff(creditInfo.issuedAt)
      return `${creditsMonthly} will be added with your next invoice on ${fullDayWithTime(renewalDay, true)}.`
    }
  }

  get pastDueMessage(): string {
    return `
      This subscription's most recent invoice is past due. ${ this.customer.subscription.quantity } ${ pluralize('credit', this.customer.subscription.quantity) } will be unusable until the invoice is paid.
    `
  }

  get pastDue(): boolean {
    return this.customer?.subscription?.state === 'active' && !!this.customer.subscription.pastDueAt
  }

  get nextCreditsInfo(): {quantity: number, issuedAt: Date} {
    const currentMonth = new Date().getMonth()
    if (this.customer.scheduledSubscription?.nextCreditsIssuedAt.getMonth() - currentMonth <= 1) {
      return {
        quantity: this.customer.scheduledSubscription.quantity,
        issuedAt: this.customer.scheduledSubscription.nextCreditsIssuedAt
      }
    } else {
      return {
        quantity: this.customer.subscription.quantity,
        issuedAt: this.customer.subscription.nextCreditsIssuedAt
      }
    }
  }
}
